// @ts-ignore
const protocol = window.location.protocol;
const hostname = window.location.hostname;

const API_PATH:string = process.env.REACT_APP_API_PATH ? process.env.REACT_APP_API_PATH : `${protocol}//${hostname}/api/`;
const LARAVEL_API_PATH:string = process.env.REACT_APP_LARAVEL_API_PATH ? process.env.REACT_APP_LARAVEL_API_PATH : `${protocol}//${hostname}/api_laravel/`;
const LARAVEL_API_TOKEN:string = process.env.REACT_APP_LARAVEL_API_TOKEN ? process.env.REACT_APP_LARAVEL_API_TOKEN : `token`;

const BOOKING_STATE_SUBSCRIPTION_PATH:string = "/app/booking-status";

// Режим тестового пользователя (для разработки без backend)
const TEST_USER_MODE:boolean = process.env.REACT_APP_TEST_USER === 'true';

export {API_PATH, LARAVEL_API_PATH, LARAVEL_API_TOKEN, BOOKING_STATE_SUBSCRIPTION_PATH, TEST_USER_MODE};